export const COLORS = {
  black: {
    DEFAULT: '#000000',
  },
  white: {
    DEFAULT: '#FFFFFF',
  },
  red: {
    light: 'rgba(240, 0, 50, 0.25)',
    DEFAULT: '#F0001C',
    hover: '#C20010',
  },
  orange: {
    DEFAULT: '#FA6000',
    hover: '#D14D00',
  },
  yellow: {
    DEFAULT: '#FFEA2E',
    hover: '#FAD900',
  },
  blue: {
    DEFAULT: '#4465F8',
    hover: '#1D3DF7',
  },
  violet: {
    DEFAULT: '#8B5CF6',
  },
  gray: {
    DEFAULT: '#d1d5db',
    hover: '#9ca3af',
    muted: '#6b7280',
    dark: '#374151',
  },
  green: {
    light: 'rgba(92, 179, 50, 0.25)',
    DEFAULT: '#5CB300',
    hover: '#4D9900',
  },
  primary: {
    DEFAULT: 'var(--primary-color)',
    hover: 'var(--primary-color-hover)',
  },
};

export const DEMO_LOGIN = 'demo+public@wirenboard.com';
export const DEMO_PASSWORD = 'demopublic';

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 50;
export const ITEMS_PER_PAGE = [25, DEFAULT_PAGE_SIZE, 75, 100];

export const METRICS_INTERVAL_MIN_S = 60;
export const METRICS_INTERVAL_MAX_S = 240;
export const METRICS_INTERVAL_DEFAULT_S = 120;
export const METRICS_INTERVAL_STEP_S = 10;
